// src/components/SkillCard.js
import React from "react";
import ProgressBar from "./ProgressBar";  // Ensure correct path

const SkillCard = ({ skill }) => {
  return (
    <div className="skill-card">
      <span className="skill-name">{skill.name}</span>
      <ProgressBar
        completed={skill.level}      // Passing skill level to show progress percentage
        bgColor="#2596be"            // Background color of the progress bar
        customLabel={`${skill.level}%`} // Custom label showing percentage on the progress bar
      />
    </div>
  );
};

export default SkillCard;
